// Mapping from role code → URL slug + dashboard variant
// Used by tenant-scoped URL routing (/<tenant-slug>/<role-slug>/...)

export const ROLE_ROUTES = {
  ORG_ADMIN: { slug: "org-admin", variant: "ORG", basePath: "/org" },
  PROCUREMENT_MANAGER: { slug: "procurement-manager", variant: "ORG", basePath: "/org" },
  FINANCE_MANAGER: { slug: "finance-manager", variant: "ORG", basePath: "/org" },
  INVENTORY_MANAGER: { slug: "inventory-manager", variant: "ORG", basePath: "/org" },
  PRODUCTION_MANAGER: { slug: "production-manager", variant: "ORG", basePath: "/org" },
  SALES_MANAGER: { slug: "sales-manager", variant: "SALES", basePath: "/sales" },
  SALES_EXECUTIVE: { slug: "sales-executive", variant: "SALES", basePath: "/sales" },
  SALES_COORDINATOR: { slug: "sales-coordinator", variant: "SALES", basePath: "/sales" },
  WAREHOUSE_MANAGER: { slug: "warehouse-manager", variant: "WAREHOUSE", basePath: "/warehouse" },
  WAREHOUSE_EXECUTIVE: { slug: "warehouse-executive", variant: "WAREHOUSE", basePath: "/warehouse" },
  DISTRIBUTOR: { slug: "distributor", variant: "DISTRIBUTOR", basePath: "/distributor" },
  DEALER: { slug: "dealer", variant: "DEALER", basePath: "/dealer" },
  VENDOR_ADMIN: { slug: "vendor-admin", variant: "VENDOR", basePath: "/vendor" },
  VENDOR_STAFF: { slug: "vendor-staff", variant: "VENDOR", basePath: "/vendor" },
  BUYER: { slug: "buyer", variant: "BUYER", basePath: "/buyer" },
};

export const SLUG_TO_ROLE = Object.fromEntries(
  Object.entries(ROLE_ROUTES).map(([code, def]) => [def.slug, code])
);

export function slugForRole(roleCode) {
  return ROLE_ROUTES[roleCode]?.slug || roleCode.toLowerCase().replace(/_/g, "-");
}

export function basePathForRole(roleCode) {
  return ROLE_ROUTES[roleCode]?.basePath || "/login";
}
